import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { Send } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

interface TestEmailButtonProps {
  email: string;
  disabled?: boolean;
}

export const TestEmailButton = ({ email, disabled }: TestEmailButtonProps) => {
  const { toast } = useToast();

  const handleSend = async () => {
    if (!email.trim()) {
      toast({
        title: "Invalid email",
        description: "Please enter a valid email address",
        variant: "destructive",
      });
      return;
    }
    
    
    try {
      // Authorization token
      const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFhcHFtb2hqZ3JoenNrbW92bHFmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzMyNDc2MjIsImV4cCI6MjA0ODgyMzYyMn0.VdNGLtiw17wg_WO6GX4OSry5fjgM2V2agM8SCif7g-A";
      
      const { data, error } = await supabase.functions.invoke('send-daily-devotionals', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body:{
          specificEmail: email,
          specificContact: "",
          type: "email",
          specificDate: new Date().toDateString(),
        },
      });

      if (error) throw error;

      toast({
        title: "Devotional sent!",
        description: "Today's devotional has been sent to your email.",
      });
    } catch (error: any) {
      console.error("Send devotional error:", error);
      toast({
        title: "Send failed",
        description: "Failed to send devotional. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="w-full gap-2"
      onClick={handleSend}
      disabled={disabled}
    >
      <Send className="h-4 w-4" />
      {disabled ? "Sending..." : "Send Today's Devotional"}
    </Button>
  );
};